import QashqoolLogo from "@/assets/images/qashqool-logo-light-slim.svg?react";
import LoginForm from "../home/LoginForm";

const DesktopLoginPage = () => {
  return (
    <section className="min-h-screen">
      <div className="container p-4 mx-auto">
        <QashqoolLogo className="mx-auto my-2 size-40" />
        <div className="flex items-center justify-center lg:w-1/3 md:w-1/2 w-full bg-white mx-auto p-4 shadow-lg border rounded-2xl desktop-login-page-form">
          <LoginForm />
        </div>
      </div>
    </section>
  );
};

export default DesktopLoginPage;
